import { FormModal } from "../base";
import { STTConfigForm, STTConfigFormData } from "./STTConfigForm";

type STTSettingsDialogProps = {
  isOpen: boolean;
  onClose: () => void;
  config: STTConfigFormData;
  onSave: (config: STTConfigFormData) => void;
  isAdmin?: boolean;
};

export const STTSettingsDialog = ({ isOpen, onClose, config, onSave, isAdmin = false }: STTSettingsDialogProps) => {
  return (
    <FormModal
      isOpen={isOpen}
      onClose={onClose}
      onSave={onSave}
      config={config}
      title="STT Settings"
      saveLabel="Save & Deploy"
    >
      {({ localConfig, onChange }) => (
        <STTConfigForm
          config={localConfig}
          onChange={onChange}
          isAdmin={isAdmin}
        />
      )}
    </FormModal>
  );
};
